import { ReadProject } from "@/types/project";
import { PROJECT_DEPENDENCY_ROLE } from "@/schemas/commonFields/projectDependsOn";

export const isProjectRoleDependent = (project?: Partial<ReadProject>) =>
  project?.project_depends_on === PROJECT_DEPENDENCY_ROLE;
